module.exports = __webpack_public_path__ + "static/media/doorman.816af8b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/doorman.svg
// module id = 541
// module chunks = 0